// @flow
import React from 'react';
import SizeGridToken from './SizeGridToken';

type Props = {
  sku: {
    available: boolean,
    skuCode: string,
    status: string,
    stockStatus: string,
    stockStatusKey: string,
  },
  selected: boolean,
  onChange: any => void,
};

const SizeGridItem = (props: Props) => {
  const formatModifier = (stockStatus, stockStatusKey) => {
    const preOrder = /^Available/gi.test(stockStatus);
    const inStock = /^In stock/gi.test(stockStatus);
    const lowStock = /^Low stock/gi.test(stockStatus);

    switch (true) {
      case preOrder:
        return 'pre-order';
      case inStock:
        return (stockStatusKey || '').toLowerCase().startsWith('lowstock')
          ? 'low-stock'
          : 'in-stock';
      case lowStock:
        return 'low-stock';
      default:
        return 'no-stock';
    }
  };

  const inputId = props.sku.skuCode;
  const modifier = formatModifier(
    props.sku.stockStatus,
    props.sku.stockStatusKey
  );
  return (
    <td>
      {props.sku.available ? (
        <span>
          <input
            id={inputId}
            className="c-size-grid__item__input"
            type="checkbox"
            data-value={inputId}
            selected={props.selected}
            onChange={() =>
              props.selected ? props.onChange(null) : props.onChange(props.sku)
            }
          />
          <label htmlFor={inputId}>
            <SizeGridToken
              modifier={`${modifier}${props.selected ? '--active' : ''}`.trim()}
            />
          </label>
        </span>
      ) : (
        <span className="c-size-grid__item--no-stock" data-value={inputId}>
          <SizeGridToken noStock />
        </span>
      )}
    </td>
  );
};

export default SizeGridItem;
